/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ActivityQueueNotificationDetails {
    getFixupPrototypeFunction() { return ActivityQueueNotificationDetails.fixupPrototype; }

    static newInstance(model: Partial<ActivityQueueNotificationDetails>): ActivityQueueNotificationDetails {
        let obj = Object.assign(new ActivityQueueNotificationDetails(), model);
        ActivityQueueNotificationDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ActivityQueueNotificationDetails>): ActivityQueueNotificationDetails {
        if (!model) return null;
        return ActivityQueueNotificationDetails.newInstance(<ActivityQueueNotificationDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ActivityQueueNotificationDetails) {
        if (!obj) return;

        models.ActivityQueueNotificationDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ActivityQueueNotificationDetails): boolean {
        Object.setPrototypeOf(obj, ActivityQueueNotificationDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.activity) {
            models.ActivityQueueNotifications.fixupPrototype(this.activity);
        }
        if (this.alerts) {
            models.ActivityQueueNotifications.fixupPrototype(this.alerts);
        }
        if (this.policies) {
            models.ActivityQueueNotifications.fixupPrototype(this.policies);
        }
        if (this.scripts) {
            models.ActivityQueueNotifications.fixupPrototype(this.scripts);
        }
        if (this.templates) {
            models.ActivityQueueNotifications.fixupPrototype(this.templates);
        }
        if (this.security_alerts) {
            models.ActivityQueueNotificationsForSecurityThreats.fixupPrototype(this.security_alerts);
        }
        if (this.inventory_update) {
            models.ActivityQueueNotifications.fixupPrototype(this.inventory_update);
        }
        if (this.automation_failure) {
            models.ActivityQueueNotifications.fixupPrototype(this.automation_failure);
        }
        if (this.budget_alerts) {
            models.ActivityQueueNotifications.fixupPrototype(this.budget_alerts);
        }
    }

    activity: models.ActivityQueueNotifications;

    alerts: models.ActivityQueueNotifications;

    policies: models.ActivityQueueNotifications;

    scripts: models.ActivityQueueNotifications;

    templates: models.ActivityQueueNotifications;

    security_alerts: models.ActivityQueueNotificationsForSecurityThreats;

    inventory_update: models.ActivityQueueNotifications;

    automation_failure: models.ActivityQueueNotifications;

    budget_alerts: models.ActivityQueueNotifications;

}
